import React from 'react'
import Container from '../Container'
import Logo from './Logo'
import Button from '../Button'
import { Link } from 'react-router-dom'
import { MdLogout } from 'react-icons/md'

export default function LandingNav({
  currentUser,
  setCurrentUser
}) {
  return (
    <div className='fixed w-full bg-white z-10 shadow-sm'>
        <div className='
            py-4
            border-b-[1px]
        '>
            <Container>
                <div className='
                    flex
                    flex-row
                    items-center
                    justify-between
                    gap-3
                    md:gap-0
                '>
                    <Logo />
                    {/* <Search /> */}
                    {currentUser.token?(
                      <div className='flex gap-3'>
                        <Link to='/connect?active=signin' onClick={() => {localStorage.removeItem('tracker_user'); setCurrentUser({})}}>
                          <Button label='Log Out' icon={MdLogout}/>
                        </Link>
                      </div>
                    ):(
                      <div className='flex gap-3'>
                        <Link to='/connect?active=signin'>
                          <Button 
                            outline
                            label='Login'
                            />
                        </Link>
                        <Link to='/connect?active=signup'>
                          <Button 
                            label='Sign up for free'
                            />
                        </Link>
                      </div>
                    )}
                    {/* <UserMenu currentUser={currentUser}/> */}
                </div>
            </Container>
        </div>
    </div>
  )
}
